import React, { useState } from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";
import CoreComponent31 from "../../../assets/Sub-component/CoreComponent31";
import CoreComponent32 from "../../../assets/Sub-component/CoreComponent32";
import "../../../assets/scss/_responsive.scss";
import "swiper/css";
import "swiper/css/navigation";
import CoreComponent35 from "../../../assets/Sub-component/CoreComponent35";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";

import ticks from "../../../assets/Services/tick-circle.png";
import CoreSlider from "../../../assets/Sub-component/CoreSlider";
import CoreSlider2 from "../../../assets/Sub-component/CoreSlider2";
import CoreComponent36 from "../../../assets/Sub-component/CoreComponent36";
import ClientExpCore from "../../../assets/Sub-component/ClientExpCore";
import CoreComponent37 from "../../../assets/Sub-component/CoreComponent37";
import { Link } from "react-router-dom";


import Unreal_Engine_Development from "../../../assets/Services/Arcade_dev/Unreal_Engine_Development.png";
import Arcade_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Arcade_Game_Development.png";
import Bingo_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Bingo_Game_Development.png";
import Board_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Board_Game_Development.png";
import Ludo_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Ludo_Game_Development.png";
import Rummy_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Rummy_Game_Development.png";
import Poker_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Poker_Game_Development.png";
import Casino_Game_Development from '../../../assets/Services/Board_game_Dev/Casino_Game_Development.png'


import Access_to_Distinguished_Expertise from '../../../assets/Services/Board_game_Dev/Exp_raiden/Access_to_Distinguished_Expertise.svg'
import Advanced_Technology_Implementation from '../../../assets/Services/Board_game_Dev/Exp_raiden/Advanced_Technology_Implementation.svg'
import Complete_regional_adaptation from '../../../assets/Services/Board_game_Dev/Exp_raiden/Complete_regional_adaptation.svg'
import Expert_Consultation_on_Strategic_Issues from '../../../assets/Services/Board_game_Dev/Exp_raiden/Expert_Consultation_on_Strategic_Issues.svg'
import Pioneering_Game from '../../../assets/Services/Board_game_Dev/Exp_raiden/Pioneering_Game-play_Innovation.svg'


import Mask_group from '../../../assets/Services/Bingo_game_dev/Client/Mask_group.png'
import Mask_group2 from '../../../assets/Services/Bingo_game_dev/Client/Maskgroup.png'
import Mask_group3 from '../../../assets/Services/Bingo_game_dev/Client/Maskgroup2.png'

import D_game from '../../../assets/Services/Bingo_game_dev/Our_End-to-End_Rummy/2D&3D_game.png'
import AR_VR_capabilities from '../../../assets/Services/Bingo_game_dev/Our_End-to-End_Rummy/AR_VR_capabilities.png'
import Desktop from '../../../assets/Services/Bingo_game_dev/Our_End-to-End_Rummy/Desktop&Mobile_game.png'
import Payout_engine from '../../../assets/Services/Bingo_game_dev/Our_End-to-End_Rummy/Payout_engine.png'
import Secure_payment from '../../../assets/Services/Bingo_game_dev/Our_End-to-End_Rummy/Secure_payment.png'

import Admin_Panel from '../../../assets/Services/Bingo_game_dev/Features_for_Developing/Admin_Panel.svg'
import Anti_Fraud from '../../../assets/Services/Bingo_game_dev/Features_for_Developing/Anti-Fraud.svg'
import Live_Bingo_Chat from '../../../assets/Services/Bingo_game_dev/Features_for_Developing/Live_Bingo_Chat.svg'
import Mobile_Bingo from '../../../assets/Services/Bingo_game_dev/Features_for_Developing/Mobile_Bingo.svg'
import Player_Tracking from '../../../assets/Services/Bingo_game_dev/Features_for_Developing/Player_Tracking.svg'

import Audio_ from '../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Audio_&_Sound.svg'
import Concept_ from '../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Concept_&_Validation.svg'
import Marketing_ from '../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Marketing_&_Launch.svg'
import Story_ from '../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Story_&_World-Building.svg'
import Systems_ from '../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Systems_&_Backend.svg'

import one from '../../../assets/Services/Game_page/bingo/one.svg'
import one2 from '../../../assets/Services/Game_page/bingo/two.svg'
import one3 from '../../../assets/Services/Game_page/bingo/three.svg'
import FaqHome from "../../../components/faq/FaqHome";
import axios from "axios";
import Contact from "../features/miscellaneous/contact";


const BingoGameDev = () => {
  const[form,setForm]=useState({name:'',email:'',mobile:'',message:''})
  const cards = [
    {
      title: " Desktop & Mobile Game Engineering ",
      desc: "  We design and create games for both desktop and mobile platforms with a focus on seamless cross-platform integration, dependable multiplayer networking, high-fidelity graphics pipelines, and real-time data handling.  ",
      img: Desktop,
    },
    {
      title: " 2D & 3D Game Development ",
      desc: " From sprite-based 2D engines to complex 3D environments, our teams implement optimized rendering, responsive controls, and robust multiplayer frameworks. We ensure compatibility across devices, with a focus on performance tuning and resource management for demanding applications  ",
      img: D_game,
    },
    {
      title: "Secure Payment Gateway Integration  ",
      desc: "  We provide integration of industry-standard payment gateways, supporting a wide range of transaction methods. Our solutions focus on transaction security, compliance, and minimizing latency, delivering a frictionless user experience for deposits and withdrawals at scale. ",
      img: Secure_payment,
    },
    {
      title: " Payout Engine & RTP Optimization ",
      desc: " Our payout systems are engineered for transparency and flexibility, allowing precise RTP configuration to balance profitability and user retention. Secure transaction management and real-time reporting are built in, ensuring both operational integrity and fair play.  ",
      img:Payout_engine ,
    },
    {
      title: " AR/VR Capabilities ",
      desc: "  Our advanced AR/VR integrations leverage device sensors, spatial tracking, and optimized rendering to produce dynamic, engaging game environments. Across all supported devices, our cross-platform frameworks enable consistent user experiences. ",
      img:AR_VR_capabilities ,
    },
 
  ];

  const pokerdevcompany = [
      {
      title: "  Pioneering Game-play Innovation ",
      icon:Pioneering_Game ,
      desc: "Raiden prefers uniqueness in creativity when it comes to game design. We actively work to add interesting features and innovative mechanics. This dedication to uniqueness sets our product apart and improves the overall gaming experience, encouraging long-term user involvement.   ",
    },
    {
      title: "  Advanced Technology Implementation ",
      icon:Advanced_Technology_Implementation ,
      desc: " We take advantage of modern technological innovations, like safe digital asset management, innovative gaming capabilities, and dependable, scalable real-time infrastructure, to ensure peak performance and future adaptability.  ",
    },
    {
      title: "  Complete regional adaptation ",
      icon: Complete_regional_adaptation,
      desc: "Our approach combines subtle localization—regionally relevant payment methods, culturally sensitive design, and extensive multilingual support—to make sure your game has a significant impact on a wide range of international player communities.   ",
    },
    {
      title: "Expert Consultation on Strategic Issues   ",
      icon: Expert_Consultation_on_Strategic_Issues,
      desc: "As the project progresses from conception to market launch, we offer crucial strategic direction. Our skilled consultants make sure your project complies with current industry norms and is positioned to optimize its competitiveness.   ",
    },
    {
      title: "  Access to Distinguished Expertise ",
      icon:Access_to_Distinguished_Expertise ,
      desc: "Our professionals can produce a polished, reliable, and market-ready unity game with accuracy and efficiency because they have a wealth of knowledge and specialized skills.   ",
    },
  ];



   const pokerdevcompany2 = [
    {
      title: "  Concept & Validation",
      icon: Concept_,
      desc: "   Every project starts with a spark. We brainstorm creative ideas, test their market potential, and shape a clear vision to guide the team from day one.  ",
    },
    {
      title: "Story & World-Building ",
      icon: Story_,
      desc: " Next, we build the heart of the game: its world and story. Our writers develop rich lore, unique characters, and a narrative that draws players into something memorable.    ",
    },
    {
      title: "  Systems & Backend",
      icon: Systems_,
      desc: " Behind every great game is solid tech. Our engineers design reliable servers, smooth multiplayer systems, and robust data management—so everything just works.    ",
    },
    {
      title: " Audio & Sound ",
      icon: Audio_,
      desc: " Sound matters. Our audio team crafts original music and immersive effects, creating an atmosphere that brings every moment to life.    ",
    },
    {
      title: "  Marketing & Launch",
      icon: Marketing_,
      desc: " Finally, we make sure your game gets noticed. From strategic marketing plans to eye-catching promos, we handle everything needed for a successful release.    ",
    },
  ]


  const gamedevservices = [
     {
      title: "Casino Game Development  ",
      icon: Casino_Game_Development,
      desc: " Deliver immersive casino classics—from slots to roulette and blackjack—integrated with secure wallets, tournament systems, live dealer support, and multilingual functionality, all within a compliance-ready framework. ",
      link: "/casino-game-development",
    },
    {
      title: "Poker  Game Development  ",
      icon: Poker_Game_Development ,
      desc: " Our poker platforms feature secure, scalable game logic, support for multiple variants, and tournament systems. We implement advanced encryption for transactions and provide intuitive user interfaces for optimal player experience.",
      link: "/poker-game-development",
    },
    {
      title: "Unreal Engine Development  ",
      icon:  Unreal_Engine_Development,
      desc: " Our mastery of Unreal Engine enables us to produce games with excellent performance and fidelity. Our pipeline offers realistic rendering, advanced physics, and scalable multiplayer architectures, and it works with both PC and console platforms.  ",
      link: "/unreal-engine-game-development",
    },
    {
      title: " Board Game Development",
      icon: Board_Game_Development ,
      desc: " Bring timeless board games like Ludo, Chess, and Monopoly to digital life with intuitive interfaces, real-time multiplayer capabilities, and socially engaging mechanics.",
      link: "/board-game-development",
    },
    {
      title: "Ludo Game Development",
      icon:  Ludo_Game_Development,
      desc: "We build modern Ludo games with real-time multiplayer, secure matchmaking, and responsive UI. Our implementations support cross-platform play and robust backend integration for analytics and user management.",
      link: "/ludo-game-development",
    },
    {
      title: " Rummy Game Development",
      icon: Rummy_Game_Development ,
      desc: " Develop scalable and secure Rummy solutions that offer smooth gameplay and high-performance backend support.",
      link: "/rummy-game-development",
    },
  ];

  const custom = [
    {
      icon:Live_Bingo_Chat ,
      title: "  Live Bingo Chat  ",
      desc: "    Real-time player interaction, community engagement, moderator support, emojis, spam filtering, and user experience enhancement are all made possible by live chat. ",
    },
    {
      icon:Anti_Fraud ,
      title: "Anti-Fraud System    ",
      desc: "   The anti-fraud system guards against transactions, stops multiple accounts, keeps an eye on questionable activity, detects cheating, and preserves the integrity of the game.  ",
    },
    {
      icon:Admin_Panel ,
      title: "  Admin Panel  ",
      desc: "     The admin panel manages users, monitors games, controls finances, configures settings, generates reports, handles promotions, and ensures smooth operations.",
    },
    {
      icon:Player_Tracking ,
      title: " Player Tracking  ",
      desc: "  Player tracking keeps tabs on engagement levels, win/loss history, betting trends, session length, fraud detection, and eligibility for loyalty programs.   ",
    },
    {
      icon:Mobile_Bingo ,
      title: "  Mobile Bingo  ",
      desc: "  We offer cross-platform compatibility, notifications, real-time multiplayer, touch controls, responsive design, social features, secure transactions, and fluid gameplay on our mobile platform.   ",
    },
    
  ];
 
  const clientexp = [
    {
      icon: Mask_group,
      name: "Timsy",

      desc: "Working with Raiden Labs has been a big success for our business.Their team of expert game developers took the time to understand our vision and delivered a high-quality game that exceeded our expectations. From the initial idea to the global launch, everything was done perfectly. We’re very happy to have partnered with a trusted game development company that truly understands the fast-paced gaming industry. We highly recommend Raiden Labs for any game development needs! ",
    },
    {
      icon:  Mask_group2,
      name: "Renita Joy  ",
      undername: " ",
      desc: "From the start, Raiden Labs showed great skill and dedication.As a company looking for a strong game development partner, we needed someone who could guide us through the challenges of creating a high-performance game that works across different platforms. With their experience, the team gave smart advice and ensured a smooth launch on all major platforms. Our game is now more engaging than ever, and our players enjoy smooth, 60 FPS gameplay. Choosing Raiden Labs as our game development company was one of the best decisions we made.",
    },
    {
      icon: Mask_group3,
      name: "  Domnick",
      undername: "  ",
      desc: "We had a great experience with Raiden Labs!Their game development services turned our idea into a beautiful, addictive game. The fact that they are a trusted game development company gave us confidence, and their team’s expertise was clear in every step of the process. Their focus on performance and attention to gameplay details is unmatched. Now we have a scalable, high-performance game that stands out in the competition. ",
    },
  ];
  const handleClick=(e)=>{
    e.preventDefault()
   axios.post('http://localhost:5000/contact',form) 
   .then((response)=>{setForm(response.data)
    console.log("data subitted successfully")
    setForm({ name: '', email: '', mobile: '', message: '' }); 
   })
   .catch((error)=>console.log("error in the api",error))
  
  }
  return (
    <div className="main-page-wrapper overflow-x-hidden">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>
      <HeaderThree />
      <div className="container  marb  "  >
        <div className="  row  text-center d-flex justify-content-center align-items-center  text-lg-start  topheader-margin " style={{ minHeight: "100vh"  }}  >
          <div className="col-lg-6">
            <h1 className="lh-1 h1-heading fs-lg-2 ">Bingo Game Development</h1>
            <p className=" mt-3 mb-2 text-center text-lg-start px-3 px-lg-0  h1-para">
              Raiden Labs has been successful in the game development industry
              for over 10+ years, creating immersive gaming environments for
              enjoyable activities and unforgettable technologies.
            </p>

            <Link to="/request-quote">
              <button className="py-2 mb-4 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a Quote
              </button>
            </Link>
          </div>
         <Contact/>
        </div>
      </div>

      <div className="container  ">
        <div className=" row">
          <div className=" col-lg-6 text-center mb-3">
            <img src={one} style={{ width: "85%" }} alt="" />
          </div>
          <div className="col-lg-6">
            <h2 className="h2-heading lh-base">
              Raiden’s Bingo Game Development Overview
            </h2>
            <p className="mt-4  h1-para" >
              Raiden Labs is one of the leading game development firms and a
              trustworthy partner for creating excellent apps. We provide expert
              game development services by the project or by the hour. Our
              objective is to offer feature-rich, fluid online games that are
              updated to reflect current market trends. Our expertise lies in
              developing highly captivating and potent games for mobile and web
              platforms that encourage user interaction and business growth.
            </p>
            <ul className="mt-3 h1-para">
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                80+ Game Developers
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                200+ successful clients
              </li>
            </ul>
            <Link to="/request-quote">
              <button className="py-2 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a custom demo
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="container mt-80 text-center">
        <h2 className="h2-heading lh-base ">
          Our Bingo Game Development Services
        </h2>
        <p className="mt-2 h1-para ">
          {" "}
          Raiden Labs provides trustworthy game development services, creating
          feature-rich, captivating games for iOS, Android, and the web with
          cutting-edge technologies. Our engineering focus ensures scalable
          architectures and dependable, high-performing experiences that
          increase user engagement and aid in the accomplishment of
          organizational objectives.
        </p>
        <CoreSlider cards={cards} />
      </div>

      <div className="mt-80  text-center bg-light pt-50 pb-50 mart">
        <div className="container">
          <h2 className="text-center lh-base  mb-3 h2-heading ">
            Features for Developing a Captivating Game
          </h2>
          <p className="mb-4 pb-2 text-center mx-lg-4">
           Raiden Labs combines technical rigor with deep gaming expertise, delivering solutions that meet demanding performance and business requirements. If you need a team that understands both code and player psychology, you’re in the right place.
          </p>
          <CoreComponent31 custom={custom} />
          <Link to="/request-quote">
            <button className="py-2 px-4 mx-auto h1-para btn-gradient rounded-3 text-white mt-3">
              Buy online poker software
            </button>
          </Link>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart">
        <div className="container p-4">
          <div className="row align-items-center   flex-column-reverse  flex-lg-row">
            <div className="col-lg-6">
              <h2 className="lh-base mb-3   h2-heading text-white text-start">
                What We Offer
              </h2>
              <p
                className="h3-para lh-base  text-lg-start"
                style={{ opacity: 0.6 }}
              >
                Unite with us for bespoke game software or casino software  engineered for high
                performance, scalability, and  a stimulating player experience.
                From conception and character design to multiplayer armature and
                live deployment, we deliver the complete technology stack  so you
                can launch, contend, and dominate in any request.{" "}
              </p>
              <Link to="/request-quote">
              <button className="py-2 mt-4 px-4 h1-para mx-auto mx-lg-0 btn-gradient rounded-3 text-white ">
                TALK WITH OUR EXPERTS NOW!
              </button>
              </Link>
            </div>
            <div className="col-lg-6">
              <img src={one2} alt=""  className="img-big-game"/>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80">
        <div className="">
          <h2 className="text-center h2-heading lh-sm">
            The Raiden Edge: Advanced Tech and a Flawless Bingo
          </h2>
          <p className="h1-para mb-4  text-center mt-3 mx-lg-4 pb-2">
            Raiden Labs integrates a skilled tech stack that supports compliance
            to create a distinctive and cutting-edge Bingo gameplay  experience.
          </p>
          <CoreComponent32  />
          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 mart">
        <div className="row">
          <div className="col-md-6">
            <h2 className="h2-heading mb-2 lh-base">
              Raiden's Universal Bingo: Seamless Across Devices{" "}
            </h2>
          </div>
          <div className="col-md-6">
            <p className="h1-para  mb-3  ">
              Raiden Labs platform's real-time synchronization and flawless
              performance guarantees enable players to switch between screens
              without losing progress. Just a lag-free, compatible experience
              that is consistent and optimized everywhere. Essentially, we
              ensure that your Unity app stays stable and usable, boosting user
              engagement on all platforms
            </p>

            <CoreComponent37  />
          </div>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart">
        <div className="container p-4">
          <div className="row align-items-center   flex-column-reverse  flex-lg-row">
            <div className="col-lg-6">
              <h2 className="h2-heading lh-base mb-2 fs-3 text-white mb-lg-3">
                Secure Your Digital World
              </h2>
             <p className="h1-para text-white  lh-base" style={{ opacity: 0.6 }}>
                Protect your business from threats. Our security specialists
                provide robust solutions to safeguard your data and fortify your
                infrastructure, giving you peace of mind.
              </p>
              <Link to="/request-quote">
                <button className="h1-para mx-auto mx-lg-0 py-2 mt-4 px-4  btn-gradient rounded-3 text-white ">
                  Let’s connect
                </button>
              </Link>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <img src={one3} alt="" className="img-big-game" />
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80 text-center">
        <h2 className="h2-heading lh-base mb-3">
         Our Bingo Game Development Process
        </h2>
        <p className="lh-base mb-3 pb-2 h1-para">
        Our process focuses on transforming an initial concept into a finished product, building a compelling world and story while engineering the underlying technology, and finalizing the experience with comprehensive audio and a strategic launch plan.
        </p>
        <div>
          <CoreComponent36 pokerdevcompany={pokerdevcompany2} />

          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 text-center ">
        <h2 className="h2-heading lh-base ">Explore our other games</h2>
        <p className="my-3 pb-2 mx-3 h1-para">
          We specialize in developing immersive and feature-rich games tailored
          for both casual and competitive players. Our expertise ensures secure,
          fair, and scalable platforms with real-time multiplayer functionality.
          With stunning visuals and intuitive gameplay, our games keep users
          engaged and coming back for more.
        </p>

        <CoreSlider2 gamedevservices={gamedevservices} />
      </div>

      <div className="container mt-80 ">
        <h2 className="text-center lh-base h2-heading ">
       Experience Raiden’s Bingo Game Development
        </h2>
        <p className="h1-para my-3 fs-6 mx-lg-4  text-center">
       We are able to translate complicated concepts into dependable, useful frameworks for understanding technical and  industry-specific demands. Our comprehensive understanding benefits customers by ensuring reliable and effective solutions.

        </p>

        <CoreComponent35 pokerdevcompany={pokerdevcompany} />
      </div>

      <div className="container mt-80 ">
        <h2 className="h2-heading lh-base mb-2 text-center">
          {" "}
          Voice of Success from our clients
        </h2>
        <p className="lh-base text-center mb-4 pb-2 h1-para">
          Hear directly from those who've partnered with us. These testimonials
          reflect Raiden Labs' commitment to excellence, innovation, and client
          satisfaction in Arcade game creation.
        </p>
        <ClientExpCore clientexp={clientexp} />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
      {/* <FaqHome/> */}

      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BingoGameDev;
